<div class="card panel-monsido-card">
    <mon-panel-header [pHeader]="'Get the Acquia Web Governance Extension' | translate"></mon-panel-header>
    <div class="card-body">
    <div class="text-center">
        <img [src]="currentExtension?.image" [attr.alt]="'Acquia Web Governance Extension'" />
    </div>
    <div class="text-center mt-5">
        <a target="_blank" aria-describedby="linkOpensInNewTab"
        [href]="currentExtension?.url">
        {{ currentExtension?.downloadLabel }}
        </a>
    </div>
    <p
        class="pt-3">
        Install the Acquia Web Governance {{ currentExtension?.label | translate:'':{extension: currentExtension?.label} }} and see QA, SEO and Accessibility issues right on your website.
        It's Visual Mode on Steroids (and it doesn't require our JS on your sites).
    </p>
    </div>
</div>
